"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  header: {
    element: 'h1',
    fontFamily: '"Museo Sans", "Verdana", sans-serif',
    fontSize: '28px',
    fontWeight: '100',
    lineHeight: '40px'
  },
  subHeader: {
    element: 'h2',
    fontFamily: '"Museo Sans", "Verdana", sans-serif',
    fontSize: '17px',
    fontWeight: '300',
    lineHeight: '24px'
  },
  sectionHeader: {
    element: 'h3',
    fontFamily: '"Museo Sans", "Verdana", sans-serif',
    fontSize: '11px',
    fontWeight: '300',
    lineHeight: '16px',
    textTransform: 'uppercase',
    letterSpacing: '1px'
  },
  bodyHeader: {
    element: 'h4',
    fontFamily: '"Museo Sans", "Verdana", sans-serif',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '16px'
  },
  bodyShort: {
    element: 'p',
    fontFamily: '"Museo Sans", "Verdana", sans-serif',
    fontSize: '14px',
    fontWeight: '300',
    lineHeight: '16px'
  },
  bodyLong: {
    element: 'p',
    fontFamily: '"Museo Sans", "Verdana", sans-serif',
    fontSize: '14px',
    fontWeight: '300',
    lineHeight: '20px'
  },
  button: {
    element: 'p',
    fontFamily: '"Museo Sans", "Verdana", sans-serif',
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: '16px',
    textTransform: 'uppercase',
    letterSpacing: '1px'
  },
  tooltipLabel: {
    element: 'span',
    fontFamily: '"Museo Sans", "Verdana", sans-serif',
    fontSize: '11px',
    fontWeight: '500',
    lineHeight: '16px'
  },
  chartLabel: {
    element: 'span',
    fontFamily: '"Museo Sans", "Verdana", sans-serif',
    fontSize: '11px',
    fontWeight: '500',
    lineHeight: '12px'
  }
};